section {
  div.title {
    padding-bottom: 35px;
  }

  &.grey {
    background-color: var(--cms-section-background-color-grey);

    lilu-fix-product-tile {
      --backdrop-color: var(--cms-section-background-color-grey);
    }
  }

  &.white {
    background-color: var(--cms-section-background-color-white);

    lilu-fix-product-tile {
      --backdrop-color: var(--cms-section-background-color-white);
    }
  }

  &.padding {
    &-top {
      &-0 {
        padding-top: 0px;
      }
      &-10 {
        padding-top: 10px;
      }
      &-25 {
        padding-top: 25px;
      }
      &-50 {
        padding-top: 50px;
      }
      &-100 {
        padding-top: 100px;
      }
    }
    &-bottom {
      &-0 {
        padding-bottom: 0px;
      }
      &-10 {
        padding-bottom: 10px;
      }
      &-25 {
        padding-bottom: 25px;
      }
      &-50 {
        padding-bottom: 50px;
      }
      &-100 {
        padding-bottom: 100px;
      }
    }
  }

  @include breakpointMin('sm') {
    &.mobile-padding {
      &-top {
        &-0 {
          padding-top: 0px;
        }
        &-10 {
          padding-top: 10px;
        }
        &-25 {
          padding-top: 25px;
        }
        &-50 {
          padding-top: 50px;
        }
        &-100 {
          padding-top: 100px;
        }
      }
      &-bottom {
        &-0 {
          padding-bottom: 0px;
        }
        &-10 {
          padding-bottom: 10px;
        }
        &-25 {
          padding-bottom: 25px;
        }
        &-50 {
          padding-bottom: 50px;
        }
        &-100 {
          padding-bottom: 100px;
        }
      }
    }
  }
}
